import styled from "styled-components";

export const ReservationContainer = styled.div<{ isApp: number | null }>`
  position: relative;
  height: 100%;
  background: white;
  display: flex;
  flex-direction: column;
  overflow-y: scroll;
  top: ${(p) => (p.isApp ? `${p.isApp}px` : "0px")};
  padding-bottom: 110px;
  > .title {
    margin: 20px 16px;

    font-size: 20px;
    font-weight: 700;
    line-height: 23.87px;
    text-align: left;
  }
`;

export const ReservationHeader = styled.div<{ isApp: number | null }>`
  z-index: 101;
  transition: all 0.1s ease-in-out;
  top: 0;
  position: fixed;
  max-width: 500px;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  height: 48px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  gap: 8px;
  padding-top: ${(p) => (p.isApp ? `${p.isApp + 12}px` : "0px")};
  padding-bottom: ${(p) => (p.isApp ? `${24}px` : "0px")};
  background-color: white;

  > .left {
    display: flex;
    align-items: center;
    gap: 8px;
    justify-content: flex-start;
  }
  .close {
    cursor: pointer;
    width: 24px;
    height: 24px;

    svg path {
      stroke: var(--Black-400, #444);
    }
  }

  .title {
    color: var(--Black-400, #444);

    font-size: 16px;
    font-weight: 600;
  }

  > .share {
    > img {
      width: 24px;
      height: 24px;
    }
  }
`;

export const TournamentImageWrapper = styled.div`
  position: relative;
  top: 0px;
  width: 100%;
  margin-top: 50px;
`;

export const TournamentImage = styled.img`
  position: relative;
  top: 0px;
  width: 100%;
`;

export const Container = styled.div`
  position: relative;
  height: 100%;
  background: white;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow-y: scroll;
`;

export const PubContainer = styled.div`
  position: relative;
  background: #f0f0f0;
  border-radius: 8px;
  margin-left: 16px;
  padding: 20px;
  width: calc(100% - 32px);
  display: flex;
  flex-direction: column;
  max-width: 400px;
  .row {
    display: flex;
    flex-direction: row;
  }
`;

export const ValueLabel = styled.label`
  font-size: 13px;
  font-weight: 400;
  line-height: 20.8px;
  letter-spacing: -0.02em;
  text-align: left;

  flex: 3;
`;

export const ButtonWrapper = styled.div`
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  height: 98px;
  z-index: 100;
  width: 100%;
  background: #fff;
  display: flex;
  flex-direction: row;
  gap: 10px;
  padding: 15px 16px;
  box-sizing: border-box;

  > .state-button {
    display: flex;
    flex-direction: column;
    align-items: center;

    > .state {
      font-weight: 600;
      font-size: 10px;
      text-align: center;
    }
  }

  > .button {
    width: 100%;
    height: 48px;
    border-radius: 8px;
    background: var(--Purple-300, #6436e7);

    font-weight: 600;
    font-size: 15px;
    line-height: 48px;
    text-align: center;
    color: #fff;

    &.cancel {
      background: #d91818;
    }
  }
`;

export const Label = styled.label`
  font-size: 13px;
  font-weight: 600;
  line-height: 20.8px;
  letter-spacing: -0.02em;
  text-align: left;

  flex: 1;
`;
export const WarningWrapper = styled.div`
  margin: 5px 16px;

  font-size: 10px;
  font-weight: 600;
  line-height: 16px;
  letter-spacing: -0.02em;
  text-align: left;
  color: #8c8a8a;
`;

export const FloatButton = styled.div`
  position: absolute;
  right: 16px;
  top: 20px;
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  > img {
    position: absolute;
    width: 100%;
    height: 100%;
  }
`;
